import axios from "@/api/axiosInstance";

export function createGroup(payload) {
  return axios.post(`/api/v1/groups`, payload);
}

export function fetchGroups(pageNumber) {
  return axios.get(`/api/v1/groups?page=${pageNumber}`);
}

export function updateGroup(payload) {
  return axios.patch(`/api/v1/groups/${payload.id}`, payload.values);
}

export function deleteGroup(payload) {
  return axios.delete(`/api/v1/groups/${payload}`);
}

export function addMember(payload) {
  return axios.post(`/api/v1/members/${payload.id}`, payload.values);
}

export function fetchGroupsBulk(pageNumber) {
  return axios.get(`/api/v1/groups?page=${pageNumber}&limit=100`);
}
